module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAAABHNCSVQICAgIfAhkiAAAAPVJREFUKFONkg2NAkEMhb91cA5Awjm4PQfgABQACkDC4QAHgAKQgIMDB3sKjnykQ5rNbLJNJpO0fX2vPw11+wAugP83cK+lNQPgHTANkP9iLFi2G/AJdFGgrbH3mWVZAX+A7Noa+AI2/QKCZwGQ6RGsAmTVVPITbVjkCpz1CTbJ5MNA/323LTjMRrCgf2A5Emy+7bWlZx0TYJ7k1moVoK12eWAG7M9Azcr63mvLYPtWjv8QWH/ZAhnsRN1vHpxKytQdlIXfyjLYFRi0gNK2aU37kGJMdS/LYAO/cVnuW3netL9sx7jzKtgjMUkFvmzlvk+h7BV7ApkHNA9xVtGzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/allSubject/cancelCollect.png
// module id = 0nXC
// module chunks = 3